var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNigeria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5217_9320)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15 30.5361C23.2843 30.5361 30 23.8203 30 15.5361C30 7.2518 23.2843 0.536072 15 0.536072C6.71573 0.536072 0 7.2518 0 15.5361C0 23.8203 6.71573 30.5361 15 30.5361Z",
    fill: "#008751"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5217_9320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 18,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0865 7.83319H9.91406C8.25721 7.83319 6.91406 9.17634 6.91406 10.8332V20.2355C6.91406 21.8923 8.25721 23.2355 9.91406 23.2355H20.0865C21.7433 23.2355 23.0865 21.8923 23.0865 20.2355V10.8332C23.0865 9.17634 21.7433 7.83319 20.0865 7.83319Z",
    fill: "#E94D1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5217_9320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 4.67157H29.5134V26.5635H0.324219V4.67157Z",
    fill: "#008751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 4.59052H19.2956V26.4824H11.1875V4.59052Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5217_9320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.536072)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeria);
export default __webpack_public_path__ + "static/media/nigeria.6e6efb02f397903d601ab9580d38c3e8.svg";
export { ForwardRef as ReactComponent };